export enum StepGraderType {
  PHONEME,
  WORD,
  LETTER_NAME,
  RHYME_SOUND,
  STORY_WORD,
  STORY_SENTENCE,
}
